import client from '/src/services/client.js';

export default {
    signIn : (data) => client.post('auth/login', data),
    //updatePassword : (data) => client.post('change/password', data)
}